import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  DISABLE_INTEGRATION_REQUEST_ASYNC as DISABLE_GSUITE_INTEGRATION,
  ENABLE_INTEGRATION_REQUEST_ASYNC as ENABLE_GSUITE_INTEGRATION,
} from './Gsuite/constants'
import { DISABLE_365_INTEGRATION_REQUEST_ASYNC as DISABLE_O365_INTEGRATION } from './O365/constants'
import {
  delExchangeInfoError,
  delExchangeInfoSuccess,
  disableMailboxError,
  disableMailboxSuccess,
  getExchangeInfoError,
  getExchangeInfoSuccess,
  getMailboxInfoError,
  getMailboxInfoSuccess,
  updExchangeInfoError,
  updExchangeInfoSuccess,
  updMailboxError,
  updMailboxSuccess,
} from './actions'
import {
  DELETE_SERVER_SIDE_ASYNC,
  DISABLE_MAILBOX_ASYNC,
  MAILBOX_REQUEST_ASYNC,
  SERVER_SIDE_REQUEST_ASYNC,
  UPDATE_MAILBOX_ASYNC,
  UPDATE_SERVER_SIDE_ASYNC,
} from './constants'

const getExchangeInfoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      SERVER_SIDE_REQUEST_ASYNC.INITIATE,
      UPDATE_SERVER_SIDE_ASYNC.SUCCESS,
      DELETE_SERVER_SIDE_ASYNC.SUCCESS,
      DISABLE_MAILBOX_ASYNC.SUCCESS,
      ENABLE_GSUITE_INTEGRATION.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    }),
    mergeMap(() =>
      api.settings.getEmailServerSettings(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getExchangeInfoSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getExchangeInfoError, error))),
        takeUntil(action$.pipe(ofType(SERVER_SIDE_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updExchangeInfoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_SERVER_SIDE_ASYNC.INITIATE),
    mergeMap((action) => {
      const currentData = state$.value.settings.emailServer.self.data || {}
      const formValues = action.payload || {}

      const payload = {
        ...currentData,
        ...formValues,
        exchangeServer: formValues.exchangeServer === '' ? null : formValues.exchangeServer,
      }

      return api.settings
        .updEmailServerSettings(state$.value.partnerOptions.selectedCompany?.value, payload)
        .pipe(
          map((response) => updExchangeInfoSuccess(response)),
          catchError((error) =>
            of(
              epicsErrorHandler(updExchangeInfoError, error),
              addToast({ message: error?.response?.message || error?.response, type: 'error' })
            )
          ),
          takeUntil(action$.pipe(ofType(UPDATE_SERVER_SIDE_ASYNC.CANCEL)))
        )
    })
  )

const delExchangeInfoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_SERVER_SIDE_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings.delExchangeCred(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => delExchangeInfoSuccess(response)),
        catchError((error) => of(epicsErrorHandler(delExchangeInfoError, error))),
        takeUntil(action$.pipe(ofType(DELETE_SERVER_SIDE_ASYNC.CANCEL)))
      )
    )
  )

const getMailboxInfoEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      MAILBOX_REQUEST_ASYNC.INITIATE,
      DELETE_SERVER_SIDE_ASYNC.SUCCESS,
      UPDATE_MAILBOX_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    }),
    mergeMap(() =>
      api.dashboard.getHeartbeat(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => getMailboxInfoSuccess(response)),
        catchError((error) => of(epicsErrorHandler(getMailboxInfoError, error))),
        takeUntil(action$.pipe(ofType(MAILBOX_REQUEST_ASYNC.CANCEL)))
      )
    )
  )

const updMailboxEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(UPDATE_MAILBOX_ASYNC.INITIATE),
    mergeMap(() =>
      api.settings
        .updMailboxInfo(
          state$.value.partnerOptions.selectedCompany?.value,
          state$.value.settings.emailServer.self.mailboxData['911']
        )
        .pipe(
          map((response) => updMailboxSuccess(response)),
          catchError((error) => of(epicsErrorHandler(updMailboxError, error))),
          takeUntil(action$.pipe(ofType(MAILBOX_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const disableMailboxEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      DISABLE_MAILBOX_ASYNC.INITIATE,
      DISABLE_GSUITE_INTEGRATION.SUCCESS,
      DISABLE_O365_INTEGRATION.SUCCESS
    ),
    mergeMap(() =>
      api.settings.disable911Mailbox(state$.value.partnerOptions.selectedCompany?.value).pipe(
        map((response) => disableMailboxSuccess(response)),
        catchError((error) => of(epicsErrorHandler(disableMailboxError, error))),
        takeUntil(action$.pipe(ofType(DISABLE_MAILBOX_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(
  getExchangeInfoEpic,
  updExchangeInfoEpic,
  getMailboxInfoEpic,
  delExchangeInfoEpic,
  updMailboxEpic,
  disableMailboxEpic
)
